/** Human-readable source labels for POST /api/webLeads — `module` field */
export const WEB_LEAD_MODULES = {
  GENERAL: "General Consultation",
  HOME: "Home Page",
  CTA: "Home CTA Section",
  FOOTER: "Footer",
  SERVICES: "Services Page",
  SVC_PMS: "Portfolio Management",
  SVC_WP: "Wealth Planning",
  SVC_RP: "Retirement Planning",
  SVC_LAS: "Loan Against Securities",
  SVC_TAX: "Tax-Efficient Investing",
  SVC_RISK: "Risk Management Planning",
  WEALTH: "Wealth Page",
  WEALTH_INV: "Investment Strategy",
  WEALTH_WM: "Wealth Management",
  WEALTH_GA: "Growth & Allocation",
  WEALTH_MCX: "MCX Commodity",
  CALC: "Calculators Page",
  CALC_EMI: "EMI Calculator",
  CALC_MF: "Mutual Fund Calculator",
  CALC_GOAL: "Goal Planning Calculator",
  CALC_TAX: "Capital Gains & Tax Calculator",
  CALC_ADV_MF: "Advanced MF Strategy Tools",
  CALC_COMPARE: "Comparison Calculator",
  CALC_INFLATION: "Inflation Calculator",
  CALC_PARTNER: "Partner Calculator",
  ABOUT: "About Page",
  CONTACT: "Contact Page",
  SUPPORT: "Support Page",
  DISCLAIMER: "Disclaimer Page",
  PRIVACY: "Privacy Policy",
  TERMS: "Terms & Conditions",
  REGULATORY: "Regulatory Information",
  NJ_WEALTH: "NJ Wealth",
  MOTILAL: "Motilal Oswal",
};

/** Legacy short codes from older URLs (?module=SVC_WP) → display label */
const LEGACY_ALIASES = Object.fromEntries(
  Object.entries(WEB_LEAD_MODULES).map(([key, label]) => [key, label]),
);
LEGACY_ALIASES.MF = WEB_LEAD_MODULES.CALC_MF;

export const DEFAULT_WEB_LEAD_MODULE = WEB_LEAD_MODULES.GENERAL;

const ALL_KNOWN_LABELS = new Set(Object.values(WEB_LEAD_MODULES));

/**
 * Resolves ?module= query value to a human-readable label for the API.
 * @param {string | null | undefined} raw
 */
export function resolveLeadModule(raw) {
  if (!raw || !String(raw).trim()) {
    return DEFAULT_WEB_LEAD_MODULE;
  }
  const value = decodeURIComponent(String(raw).trim());
  if (LEGACY_ALIASES[value]) {
    return LEGACY_ALIASES[value];
  }
  if (ALL_KNOWN_LABELS.has(value)) {
    return value;
  }
  return value;
}
